/* VIVID — Explainer film (sections/vh-film.liquid). Plays the scenes in turn while at least
   half the frame is on screen; segments show progress and jump to a scene; the button pauses.
   Each scene's SVG (including its SMIL motion) only runs while that scene is showing.
   Reduced motion: the section becomes a still list (.is-still). */
(function () {
  if (window.VHFilm) return;
  window.VHFilm = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root._vhFilm) return;
    const scenes = [...root.querySelectorAll('.vh-film__scene')];
    const segs = [...root.querySelectorAll('.vh-film__seg')];
    const play = root.querySelector('[data-play]');
    if (!scenes.length) return;

    if (reduce.matches) {
      root.classList.add('is-still');
      scenes.forEach((s) => s.setAttribute('aria-hidden', 'false'));
      return;
    }

    const dur = (parseFloat(root.dataset.duration) || 4.5) * 1000;
    const svgs = scenes.map((s) => s.querySelector('svg'));
    let index = 0, elapsed = 0, t0 = 0, raf = 0, playing = false, visible = false;
    let held = root.dataset.autoplay === 'false';   // paused by the shopper (or by the setting)

    const fill = (n, p) => {
      const bar = segs[n] && segs[n].querySelector('span');
      if (bar) bar.style.setProperty('--p', p);
    };
    const show = (i) => {
      index = (i + scenes.length) % scenes.length;
      scenes.forEach((s, n) => {
        const on = n === index;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', String(!on));
        const svg = svgs[n];
        if (svg && svg.pauseAnimations) (on && playing) ? svg.unpauseAnimations() : svg.pauseAnimations();
      });
      segs.forEach((b, n) => {
        b.setAttribute('aria-selected', String(n === index));
        fill(n, n < index ? 1 : 0);
      });
      elapsed = 0;
      t0 = performance.now();
    };

    const tick = (t) => {
      raf = 0;
      if (!playing) return;
      elapsed = t - t0;
      const p = Math.min(1, elapsed / dur);
      fill(index, p.toFixed(3));
      if (p >= 1) show(index + 1);
      raf = requestAnimationFrame(tick);
    };
    const label = () => {
      if (!play) return;
      play.setAttribute('aria-pressed', String(!held));
      play.setAttribute('aria-label', held ? play.dataset.labelPlay : play.dataset.labelPause);
    };
    const update = () => {
      const run = visible && !held && !document.hidden;
      if (run === playing) return label();
      playing = run;
      const svg = svgs[index];
      if (svg && svg.pauseAnimations) run ? svg.unpauseAnimations() : svg.pauseAnimations();
      root.classList.toggle('is-playing', run);
      if (run) {
        t0 = performance.now() - elapsed;
        raf = requestAnimationFrame(tick);
      } else if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
      label();
    };

    const onPlay = () => { held = !held; update(); };
    const onSeg = (e) => {
      const b = e.target.closest('[data-go]');
      if (!b) return;
      show(Number(b.dataset.go) - 1);
      if (playing) t0 = performance.now();
    };
    const onVis = () => update();
    if (play) play.addEventListener('click', onPlay);
    root.addEventListener('click', onSeg);
    document.addEventListener('visibilitychange', onVis);

    const io = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      update();
    }, { threshold: [0, 0.5, 1] });
    io.observe(root.querySelector('.vh-film__frame') || root);

    show(0);
    update();

    root._vhFilm = () => {
      io.disconnect();
      if (raf) cancelAnimationFrame(raf);
      if (play) play.removeEventListener('click', onPlay);
      root.removeEventListener('click', onSeg);
      document.removeEventListener('visibilitychange', onVis);
    };
  };
  const teardown = (root) => { if (root._vhFilm) { root._vhFilm(); delete root._vhFilm; } };

  if (window.VH && VH.section) VH.section('[data-vh-film]', init, teardown);
  else document.querySelectorAll('[data-vh-film]').forEach(init);
})();
